import { i18n } from "@/frontend/i18n";
import { BigNumber } from "bignumber.js";
import Vue from "vue";

// Clone BN constructor to avoid global pollution
const BN_ROUND_FLOOR = BigNumber.clone({ ROUNDING_MODE: 3 });

Vue.filter("toPoint", function(amount) {
  const precision = 2;
  const coin = new BN_ROUND_FLOOR(amount);
  const pointNumber = coin.toFormat(precision);
  return `${pointNumber} ${i18n.tc("Point", Number(pointNumber))}`;
});

Vue.filter("toABX", function(amount) {
  const precision = 2;
  const coin = new BN_ROUND_FLOOR(amount);
  const pointNumber = coin.toFormat(precision);
  return `${pointNumber} ABX`;
});

Vue.filter("toYEN", function(amount) {
  const precision = 0;
  const coin = new BigNumber(amount);
  return `¥${coin.toFormat(precision)}`;
});

Vue.filter("toDisplayCurrency", function(amount) {
  const precision = 0;
  const coin = new BigNumber(amount);
  return `${coin.toFormat(precision)}`;
});

Vue.filter("toDisplayCurrencyWithUnit", function(amount) {
  const precision = 0;
  const coin = new BigNumber(amount);
  return `${coin.toFormat(precision)}${i18n.tc("Point", amount)}`;
});

Vue.filter("toKPoint", function(amount) {
  const precision = 0;
  const point = new BigNumber(amount);
  return `${point.toFormat(precision)} KP`;
});

Vue.filter("toETH", function(amount) {
  const precision = 5;
  const point = new BigNumber(amount);
  return `${point.toFormat(precision)} ETH`;
});

Vue.filter("toRP", function(amount) {
  const precision = 4;
  const point = new BigNumber(amount);
  return `${point.toFormat(precision)} RP`;
});
